module.exports = __webpack_public_path__ + "img/3D1F12_653821_070404_22130B-256px.a42cf74c.png";